module.exports = __webpack_public_path__ + "components/home-header/static/header-6--huge-2d4d0b714fc084a3819fa8ff8a29c07d.jpg";